import { combineReducers } from 'redux';
import LoadingReducer from './LoadingReducer';
import AlertReducer from './AlertReducer';
import AuthReducer from './AuthReducer';
import CompaniesReducer from './CompaniesReducer';
import SmsReducer from './SmsReducer';
import EmailReducer from './EmailReducer';
import FeedbackReducer from './FeedbackReducer';
import MasterReducer from './MasterReducer';
import HospitalReducer from './HospitalReducer';
import DoctorReducer from './DoctorReducer';
import DrugReducer from './DrugReducer';
import ReferralReducer from './ReferralReducer';
import RealtimeReducer from './RealtimeReducer';
import ChatsReducer from './ChatsReducer';
import PatientReducer from './PatientReducer';
import ReportReducer from './ReportReducer';
import WhitelabelReducer from './WhitelabelReducer';
import CallQueueReducer from './CallQueueReducer';

export default combineReducers({
  loading: LoadingReducer,
  alert: AlertReducer,
  auth: AuthReducer,
  companies: CompaniesReducer,
  sms: SmsReducer,
  email: EmailReducer,
  feedback: FeedbackReducer,
  master: MasterReducer,
  hospital: HospitalReducer,
  doctor: DoctorReducer,
  drug: DrugReducer,
  referral: ReferralReducer,
  realtime: RealtimeReducer,
  chats: ChatsReducer,
  patient: PatientReducer,
  report: ReportReducer,
  whitelabel: WhitelabelReducer,
  callQueue: CallQueueReducer
});
